/**
 * Incident Error Type Mapper
 * Maps transport layer DTOs to domain models
 */

import type { LC_GetIncidentErrorTypesOut, IncidentErrorType } from './incidentType.types';

/**
 * Maps incident error types response from backend to UI domain model
 */
export const mapIncidentErrorTypes = (
  out: LC_GetIncidentErrorTypesOut,
): IncidentErrorType[] => {
  if (!out) return [];
  return out.map((type) => ({ 
    id: type.errorTypeId, 
    description: type.name || '', 
  }));
};
